import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SNModalService } from '@web-services/modal/snModal.service';
import {
	ActionButtonClick,
	ActionButtonResolve,
	GeneralAction,
	GeneralActions
} from '@models/models';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalComponent } from '@web-components/common/alert-modal/alert-modal.component';

@Component({
	selector: 'buttons-handler',
	template: require('./buttons-handler.component.html'),
	styles: [require('./buttons-handler.component.scss')]
})
export class ButtonsHandlerComponent implements OnInit {
	@Input() actions;
	@Output() onBtnClick: EventEmitter<ActionButtonClick> = new EventEmitter();
	@Output()
	onActionResolve: EventEmitter<ActionButtonResolve> = new EventEmitter();

	actionList: Array<string> = [];
	private modalRef: NgbModalRef;

	constructor(
		private snModalService: SNModalService,
		private iframeService: IframeService
	) {}

	ngOnInit(): void {
		this.createActionList(this.actions);
	}

	createActionList(actions: GeneralActions): void {
		this.actionList = Object.keys(actions);
	}

	performAlertAction(action: GeneralAction, type: string): void {
		this.onBtnClick.emit({ action, type });
		this.modalRef = this.snModalService.openModal(AlertModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});
		this.modalRef.componentInstance.title = action.alertMessage.title;
		this.modalRef.componentInstance.message = action.alertMessage.message;

		this.modalRef.result
			.then(data => this.onActionResolve.emit({ action, type, payload: data }))
			.catch();
	}

	performFrameAction(action: GeneralAction, type: string): void {
		this.onBtnClick.emit({ action, type });
		this.iframeService.setUrlIframe(action.url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/buttons-handler/buttons-handler.component.ts